export interface GmailComposeParams {
  to: string;
  subject?: string;
  body?: string;
  cc?: string;
  bcc?: string;
}

/** Gmail web compose URL (opens mail.google.com in the browser). */
export function buildGmailComposeUrl(params: GmailComposeParams): string {
  const to = params.to.trim();
  if (!to) throw new Error('Recipient email is required');

  const query = new URLSearchParams({
    view: 'cm',
    fs: '1',
    to,
  });

  const subject = params.subject?.trim();
  if (subject) query.set('su', subject);

  const body = params.body?.trim();
  if (body) query.set('body', body);

  const cc = params.cc?.trim();
  if (cc) query.set('cc', cc);

  const bcc = params.bcc?.trim();
  if (bcc) query.set('bcc', bcc);

  return `https://mail.google.com/mail/?${query.toString()}`;
}

export function buildConnectionFollowUpTemplate(greetingName: string): {
  subject: string;
  body: string;
} {
  const greeting = greetingName.trim() || 'there';
  return {
    subject: 'Following up',
    body: `Hi ${greeting},

Great connecting — wanted to follow up on our conversation.

[Add your note here]

Best,
Stephan`,
  };
}

export function openGmailCompose(params: GmailComposeParams): void {
  window.open(buildGmailComposeUrl(params), '_blank', 'noopener,noreferrer');
}

/** Open Gmail compose for a CRM connection with a default follow-up draft. */
export function openConnectionFollowUpInGmail(input: {
  email: string;
  greetingName?: string | null;
}): void {
  const email = input.email.trim();
  if (!email) return;

  const { subject, body } = buildConnectionFollowUpTemplate(input.greetingName ?? '');
  openGmailCompose({ to: email, subject, body });
}
